import React, { useState } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import RadioQuestion from "../../components/RadioQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";

export const NUMBER_OF_LOANS_OPTIONS = [
  { title: "1", value: 1 },
  { title: "2", value: 2 },
];

const LendingMoney = ({ lendingMoney, onStepComplete }) => {
  const [formState, setFormState] = useState({
    numberOfSource: lendingMoney?.numberOfSource ?? null,
  });
  const [errors, setErrors] = useState({});
  const [errorMessages] = useState({
    numberOfSource: "Please choose an option",
  });

  const handleInputChange = (field) => (value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleValidation = () => {
    let newErrors = {};
    let formIsValid = true;

    if (formState.numberOfSource === null) {
      newErrors.numberOfSource = true;
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleRadioValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    setErrors((prev) => {
      let newErrors = { ...prev };

      if (!isBlur) {
        newErrors[field] = false;
      } else {
        if (formState[field] === null) {
          newErrors[field] = true;
        }
      }

      return newErrors;
    });
  };

  const saveLendingMoney = (event) => {
    event.preventDefault();

    if (handleValidation()) {
      onStepComplete({
        lendingMoney: {
          numberOfSource: formState.numberOfSource,
        },
      });
    }
  };

  return (
    <React.Fragment>
      <ScrollToTop />
      <Card title="Tell us about the loans you are taking out" removeTopPadding>
        <p>
          First, we need to know how many loans from a person or bank (not including a mortgage), you are taking out to
          pay for your property.
        </p>

        <RadioQuestion
          question="How many loans are you taking out?"
          options={NUMBER_OF_LOANS_OPTIONS}
          inline={false}
          name="numberOfSource"
          selected={formState.numberOfSource}
          optionSelected={handleInputChange("numberOfSource")}
          validate={handleRadioValidation("numberOfSource")}
          validationError={errors.numberOfSource ? errorMessages.numberOfSource : null}
        />

        <Action onClick={saveLendingMoney}>Continue</Action>
      </Card>

      <Image src={imageCatAndHousePlant} />
    </React.Fragment>
  );
};

export default LendingMoney;
